import { classNames } from '@/shared/utils';
import { RightOutlined } from '@ant-design/icons';
import { useState } from 'react';
import styles from './VersionBlock.module.css';
import { renderMarkdown } from '../../utils/renderMarkdown';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';

export const VersionBlock = ({ title, content }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const markdownContent = renderMarkdown(content);

  dayjs.locale('ru');

  const blockDate = title.match(/\d\d-\d\d-\d\d\d\d/)[0];

  const blockTitle = `${title.replace(blockDate, dayjs(blockDate, 'DD-MM-YYYY').format('DD MMM YYYY'))}г.`;

  return (
    <div className={styles.block}>
      <div
        className={classNames(styles.blockHeader, { [styles.blockHeaderOpened]: isExpanded })}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span style={{ marginRight: '10px' }}>
          <RightOutlined className={classNames(styles.blockIcon, { [styles.blockIconOpened]: isExpanded })} />
        </span>
        <h2 style={{ margin: 0 }}>{blockTitle}</h2>
      </div>

      <div
        style={{ maxHeight: `${markdownContent.length * 40}px` }}
        className={classNames(styles.blockContent, { [styles.blockContentClosed]: !isExpanded })}
      >
        {markdownContent}
      </div>
    </div>
  );
};
